import { Injectable } from '@angular/core';
import { CommandService } from './command.service';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class ParamsService extends CommandService {
  constructor() {
    super(new ToastController());
  }

  sendMessage() {
    this.ble
      .writeWithoutResponse(
        this.device.bleId,
        this.device.serviceUUID,
        this.device.txUUID,
        this.hexTobytes(this.cmd)
      )
      .then(
        (data) => {
          console.log('Result Write : ', data);
        },
        (err) => {
          console.log(err);
        }
      );
  }

  public prepareCmd(task) {
    this.cmd = '3A25';
    this.cmd +=
      this.completeCmdWithZero('01', 4) +
      this.completeCmdWithZero(task.params[0].index, 4) +
      this.completeCmdWithZero(task.params[0].rawValue.length / 2, 4) +
      task.params[0].rawValue;

    console.log(this.cmd);

    // this.cmd = "3F2401000100";

    this.sendMessage();
  }

  public receiveResponse(data: any) {
    /* console.log("response write params");
        console.log(this.buf2hex(data).toLowerCase());*/

    return this.buf2hex(data).toLowerCase();
  }

  public readParam(registre) {
    this.cmd = '3F240100' + this.completeCmdWithZero(registre.toString(16), 4);

    this.sendMessage();
  }

  private completeCmdWithZero(s, i) {
    let j = 0;
    let z = '';

    s = s.toString(16);
    i = i - s.length;

    /*console.log("Valeur final de s : ", s)
  console.log("Taille de i :", i );*/

    var zero = '';
    while (j < i) {
      zero += '0';
      j++;
    }

    s = this.littleToBigEndian(zero + s);

    //console.log(s);
    return s;
  }
}
